export default __webpack_public_path__ + "static/media/42_desktop.df6a4a15.jpg";